import React from 'react';

import styles from './LoadingRow.scss';

const LoadingRow = () => {

	return (

		<div className={styles.loadingRow}>
			<div className={styles.dot}/>
			<div className={styles.dot}/>
			<div className={styles.dot}/>
			<div className={styles.dot}/>
			<div className={styles.dot}/>
			<div className={styles.dot}/>
		</div>
	);
};

export default LoadingRow;